type DueDaysBounds = { min: number; max: number };

const DUE_DAYS = {
    DEFAULT: 30,
    MAX: 365,
    MIN_DATE: '1900-01-01',
    MAX_DATE: '2500-12-31',
    BOUNDS: {
        // Matches the backend CHECK constraint on organisations.default_invoice_due_days.
        DEFAULT: { min: 1, max: 365 },

        // A due date may legitimately equal the invoice date (0 days).
        INVOICE: { min: 0, max: 365 },
    } satisfies Record<string, DueDaysBounds>,
};

export type { DueDaysBounds };

export { DUE_DAYS };
